import { CommonResponse } from '@gtpl/shared-models/production-management';
import { InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError, errorHandler, ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { Any } from 'typeorm';
import { SupplierCreationDto } from './dto/supplier-mapping.dto';
import { SupplierMappingService } from './supplier-mapping.service';
import * as bcrypt from 'bcrypt'
import { SupplierIdReq, SupplierLoginDto } from './dto/supplier-login-dto';
import { SupplierThemeDto } from './dto/supplier-theme-dto';
@ApiTags('supplier-mapping')
@Controller('supplier-mapping')
export class SupplierMappingController {
    constructor(
        private supplierMappingService: SupplierMappingService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,
    ) { }

    @Post('/create')
    async create(@Body() dto: SupplierCreationDto): Promise<CommonResponse> {
        try {
            console.log(dto);
            dto.password = await bcrypt.hash(dto.password, 12);
            return await this.supplierMappingService.create(dto);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }

    @Post('/login')
    async login(@Body() dto: SupplierLoginDto): Promise<CommonResponse> {
        try {
            return await this.supplierMappingService.login(dto);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }

    @Post('/getRegisteredSuppliers')
    async getRegisteredSuppliers(): Promise<CommonResponse> {
        try {
            return await this.supplierMappingService.getRegisteredSuppliers();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }

    @Post('/updatePassword')
    async updatePassword(@Body() dto: SupplierLoginDto): Promise<CommonResponse> {
        try {
            dto.password = await bcrypt.hash(dto.password, 12);
            console.log(dto.password,'--dto password--')
            return await this.supplierMappingService.updatePassword(dto);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }

    @Post('/updateUserTheme')
    async updateUserTheme(@Body() dto: SupplierThemeDto): Promise<CommonResponse> {
        try {   
            return await this.supplierMappingService.updateUserTheme(dto);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }

    @Post('addProfilePhoto')
    async addProfilePhoto(@Body() profileDto: any) {
        try {
            return await this.supplierMappingService.addProfilePhoto(profileDto.filesData, profileDto.id);
        } catch (error) {
            return error;
        }
    }
    @Post('/ActivateOrDeactivateSupplier')
    async ActivateOrDeactivateSupplier(@Body() req: any): Promise<CommonResponse> {
      try {
        return await this.supplierMappingService.ActivateOrDeactivateSupplier(req)
      } catch(error) {
        return this.applicationExceptionhandler.returnException(CommonResponse,error)
      }
    }


}